import { RouteConfig } from 'vue-router';
import AppsEmployeeStart from '@/apps/employee/views/Start.vue';
import AppsEmployeeLogin from '@/apps/employee/views/Login.vue';
import AppsEmployeeMain from '@/apps/employee/views/Main.vue';
import AppsEmployeeWorkingimages from '@/apps/employee/views/Workingimages.vue';
import AppsEmployeeRepairExtension from '@/apps/employee/views/RepairExtension.vue';
import AppsEmployeeRepairProof from '@/apps/employee/views/RepairProof.vue';
import AppsEmployeeRepairPlanTasks from '@/apps/employee/views/RepairPlanTasks.vue';
import AppsEmployeeRepairPlanTasksDetail from '@/apps/employee/views/RepairPlanTasksDetail.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/apps/employee/',
		name: 'AppsEmployeeStart',
		component: AppsEmployeeStart,
		meta: {
			mitarbeiterapp: true,
			guest: true,
		},
	},
	{
		path: '/apps/employee/login',
		name: 'AppsEmployeeLogin',
		component: AppsEmployeeLogin,
		meta: {
			mitarbeiterapp: true,
			guest: true,
		},
	},
	{
		path: '/apps/employee/main',
		name: 'AppsEmployeeMain',
		component: AppsEmployeeMain,
		meta: {
			mitarbeiterapp: true,
		},
	},
	{
		path: '/apps/employee/workingimages',
		name: 'AppsEmployeeWorkingimages',
		component: AppsEmployeeWorkingimages,
		meta: {
			mitarbeiterapp: true,
		},
	},
	{
		path: '/apps/employee/repairextension',
		name: 'AppsEmployeeRepairExtension',
		component: AppsEmployeeRepairExtension,
		meta: {
			mitarbeiterapp: true,
		},
	},
	{
		path: '/apps/employee/repairproof',
		name: 'AppsEmployeeRepairProof',
		component: AppsEmployeeRepairProof,
		meta: {
			mitarbeiterapp: true,
		},
	},
	{
		path: '/apps/employee/repairplan',
		name: 'AppsEmployeeRepairPlanTasks',
		component: AppsEmployeeRepairPlanTasks,
		meta: {
			mitarbeiterapp: true,
		},
	},
	{
		path: '/apps/employee/repairplan/:taskid',
		name: 'AppsEmployeeRepairPlanTasksDetail',
		component: AppsEmployeeRepairPlanTasksDetail,

		meta: {
			mitarbeiterapp: true,
		},
	},
];

export default routes;
